.schemaPartList {
  padding: 0.5em;
  border: 1px solid var(--mediumSilver);
}

.draggingList {
  border-color: var(--blue);
}

.schemaPartItem {
  display: flex;
  justify-content: space-between;
  color: var(--white);
  background-color: var(--blue);
  user-select: none;
  border-bottom: 0.1em solid var(--white);

  & div {
    padding: 1em 0.5em;
    min-width: 4em;
    overflow: hidden;
  }

  &:hover {
    background-color: var(--darkBlue);
  }
}

.disabledItem {
  cursor: default;

  &:hover {
    background-color: var(--blue);
  }
}

.codeItem {
  flex: 2;
  padding-left: 1.5em !important;
  word-wrap: break-word;

  p {
    margin-bottom: 0;
  }
}

.version {
  flex: 2;
  display: flex;

  p {
    margin-bottom: 0;
  }
}

.titleItem {
  flex: 6 4;
}

.descriptionItem {
  flex: 6 4;
}

.controlItem {
  text-align: right;
  flex: 2;
  padding-right: 1.5em !important;
}

.itemDragging {
  background-color: var(--darkBlue);
}

.dragIcon {
  margin-left: 1rem;
}

.controlIcon {
  position: relative;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: var(--white);
  top: -2px;
  padding-left: 0.5em;

  &:hover {
    color: var(--white);
  }
}
